//外租车辆运行管理
export default [{
  path: 'vehicleCarRentAdd',
  name: 'vehicleCarRentAdd',
  component: function component() {
    return import('@/views/vehicleCarRentManage/add');
  }
}, {
  path: 'vehicleCarRentUpdata',
  name: 'vehicleCarRentUpdata',
  component: function component() {
    return import('@/views/vehicleCarRentManage/updata');
  }
}, {
  path: 'vehicleCarRentList',
  name: 'vehicleCarRentList',
  component: function component() {
    return import('@/views/vehicleCarRentManage/list');
  }
}, {
  path: 'vehicleCarRentStatistics',
  name: 'vehicleCarRentStatistics',
  component: function component() {
    return import('@/views/vehicleCarRentManage/statistics');
  }
}];